import config from '@/utils/ApiUtils'
import { fetchWithToken } from '../utils/Keycloak'


export default {
  getLogo (id) {
    // on choisit le logo de l'enseigne du client en fonction de l'idEnseigne
    if (id === 1) {
      return require('@/assets/enseignes/leclerc.png')
    } else if (id === 2) {
      return require('@/assets/enseignes/superu.png')
    } else if (id === 3) {
      return require('@/assets/enseignes/intermarche.png')
    } else if (id === 4) {
      return require('@/assets/enseignes/pecherie.png')
    }else if (id === 5) {
      return require('@/assets/enseignes/carrefour.png')
    } else {
      return require('@/assets/hublot_loader.png')
    }
  },
  create (client) {
    return fetchWithToken(config().shopbackend, {
      method: 'POST',
      body: JSON.stringify(client)
    })
      .then(response => response.text())
      .then(text => {
        // Essayer de parser en JSON
        return Promise.resolve()
          .then(() => JSON.parse(text))
          .catch(() => {
            // Si ce n'est pas du JSON, retourner un objet
            console.log('[CustomerService] create returned text:', text)
            return { status: text, success: true, client }
          })
      })
  },
  update (client) {
    return fetchWithToken(config().shopbackend + client.clientId, {
      method: 'PUT',
      body: JSON.stringify(client)
    })
      .then(response => response.text())
      .then(text => {
        console.log('[CustomerService] update response:', text)
        // Essayer de parser en JSON
        return Promise.resolve()
          .then(() => JSON.parse(text))
          .catch(() => {
            // Si ce n'est pas du JSON (ex: "updated"), retourner un objet
            console.log('[CustomerService] update returned text:', text)
            return { status: text, success: text === 'updated', client }
          })
      })
  },
  get () {
    return fetchWithToken(config().shopbackend, {
      method: 'GET'
    }).then(response => {
      return response.json()
    })
  },
  getFromUrl (url) {
    return fetchWithToken(url, { method: 'GET' }).then(response => response.json())
  },
  getById (clientId) {
    return fetchWithToken(config().shopbackend + `?clientId=${clientId}`, {
      method: 'GET'
    }).then(response => response.json())
      .then(rows => rows[0] || null)
  },
  getEnseigne () {
    return fetchWithToken(config().shopbackend + 'v2/enseigne', {
      method: 'GET'
    }).then(response => response.json())
  },
  
  /**
   * Recherche d'entreprises via l'API data.gouv
   * @param {string} query - Terme de recherche
   */
  discoverEnterprise(query) {
    if (!query || query.trim().length < 2) {
      return Promise.resolve([]);
    }
    
    return fetchWithToken(`${config().discoverBackend}?q=${encodeURIComponent(query)}`, {
      method: 'GET'
    }).then(response => {
      if (!response.ok) throw new Error('Erreur lors de la recherche');
      return response.json();
    }).catch(error => {
      console.error('Erreur recherche entreprise:', error);
      return [];
    });
  }
}
